
export default function WhatsAppButton() {
  const phoneNumber = '34616308549';
  const message = encodeURIComponent('Hola, me gustaría obtener más información sobre sus soluciones de robótica.');
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-green-500 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 flex items-center justify-center cursor-pointer group"
      aria-label="Contactar por WhatsApp"
    >
      <i className="ri-whatsapp-line text-2xl"></i>
      
      {/* Tooltip */}
      <span className="absolute right-16 bg-gray-900 text-white text-sm px-3 py-2 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap pointer-events-none">
        Chatea con nosotros
      </span>
    </a>
  );
}
